



































































































































import Vue from "vue";
import store from "@/store/index";
import statusCodes from "@/config/status-codes";

export default Vue.extend({
  name: "SpeedTyping",

  data() {
    return {
      randomText: "",
      markedText: "",
      typedText: "",
      startTime: 0,
      started: false,
      finished: true,
      currentAttempt: 0,
      attemptsNum: 3,
      textLength: 70,
      wordLength: 10,
      charsCount: 0,
      typingCount: 0,
      typingSpeed: 0,
      typingAccuracy: 0,
      typingResults: [] as Array<{
        accuracy: number,
        speed: number
      }>,
      isValidChar: true,
      readonly: true,
      generationProcess: false,
      currentTimer: 6,
      countdownTimer: null,
      resultSaving: false
    };
  },

  async beforeRouteEnter(to, from, next) {
    const examsList = store.state.general.examsList;

    if (!examsList.hasOwnProperty("typeSpeed")) {
      next("/");
    } else {
      try {
        if (examsList.typeSpeed.finished) {
          next("/");
        } else {
          if (!examsList.typeSpeed.started) {
            Vue.set(store.state.typing, "loading", true);
            await store.dispatch("typing/startTypingExam");
            Vue.set(examsList.typeSpeed, "started", true);
            Vue.set(store.state.typing, "loading", false);
          }

          next();
        }
      } catch (e) {
        Vue.set(store.state.typing, "loading", false);

        if (e.code === statusCodes.CONCURRENT_EXAM) {
          next("/");
        } else {
          Vue.set(store.state.general, "exception", true);
        }
      }
    }
  },

  computed: {
    progress(): number {
      return Math.round(this.charsCount * 100 / this.randomText.length);
    },
    color(): string {
      if (this.isValidChar) {
        return "success";
      }

      return "error";
    }
  },

  watch: {
    currentAttempt(attempt) {
      localStorage.typingAttempt = attempt;
    }
  },

  mounted() {
    if (localStorage.typingAttempt) {
      this.currentAttempt = localStorage.typingAttempt;
    }
  },

  methods: {
    async startTest() {
      this.currentAttempt++;
      this.generationProcess = true;

      try {
        await this.$store.dispatch("typing/getRandomText");
        this.randomText = this.$store.state.typing.randomText
          .substring(0, this.textLength)
          .replace(/\s$/, ".");
      } catch (e) {
        console.error(e);
        this.randomText = this.randomTextGenerator();
      }

      this.generationProcess = false;
      this.initData();
      this.runCountdownTimer();
    },

    finishTest() {
      this.finished = true;
      this.readonly = true;
      this.typingResults.push({
        speed: this.typingSpeed,
        accuracy: this.typingAccuracy
      });
    },

    randomTextGenerator() {
      const lettersUC = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      const lettersLC = "abcdefghijklmnoprstuvwxyz".split("");
      const digits = "0123456789".split("");
      const specialChars = "();:\",.&?!<>=-+*%$_".split("");

      const charsCategories = [
        lettersLC,
        lettersLC,
        lettersLC,
        lettersLC,
        lettersLC,
        lettersLC,
        lettersLC,
        lettersLC,
        lettersUC
        // digits,
        // specialChars
      ];

      let randomText = "";

      for (let i = 0; i < this.textLength; i++) {
        if (i > 0 && i % this.wordLength === 0) {
          randomText += " ";
        } else {
          const category = charsCategories[Math.floor(Math.random() * charsCategories.length)];
          randomText += category[Math.floor(Math.random() * category.length)];
        }
      }

      return randomText;
    },

    typingHandler(e) {
      const currentKey = e.key;

      if (!this.started || this.finished || currentKey.length !== 1) {
        return;
      }

      this.isValidChar = this.validate(currentKey);

      if (this.isValidChar) {
        this.typedText += currentKey;
        this.markedText = this.markText(++this.charsCount, "success");
      } else {
        this.markedText = this.markText(this.charsCount, "error");
      }

      this.typingCount++;
      this.calcResult();

      if (this.charsCount === this.randomText.length) {
        this.finishTest();
      }
    },

    markText(index, level) {
      if (index >= this.randomText.length) {
        return this.randomText;
      }

      const symbols = this.randomText.split("");
      symbols[index] = `<span class="mark--${level}">${symbols[index]}</span>`;
      return symbols.join("");
    },

    validate(key) {
      return key === this.randomText.charAt(this.charsCount);
    },

    calcResult() {
      const typingTime = ((new Date().getTime() - this.startTime) / 1000) / 60;
      const speed =  Math.round(this.charsCount / typingTime);

      this.typingSpeed = !speed || speed > 1000 ? this.typingSpeed : speed;
      this.typingAccuracy = Math.round(this.charsCount * 100 / this.typingCount);
    },

    async saveResult() {
      this.resultSaving = true;
      let speed = 0;
      let accuracy = 0;

      this.typingResults.forEach((result) => {
        if (result.speed > speed) {
          speed = result.speed;
          accuracy = result.accuracy;
        }
      });

      try {
        await this.$store.dispatch("typing/saveTypingResult", {speed, accuracy});
        Vue.set(this.$store.state.general.examsList.typeSpeed, "finished", true);
        Vue.set(this.$store.state.general.examsList.typeSpeed, "started", false);
        localStorage.clear();
        this.$router.push({name: "home"});
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }

      this.resultSaving = false;
    },

    runCountdownTimer() {
      if (--this.currentTimer > 0) {
        setTimeout(this.runCountdownTimer, 1000);
        return;
      }

      this.readonly = false;
      (this.$refs.typing as HTMLElement).focus();
      this.startTime = new Date().getTime();
      this.started = true;
    },

    initData() {
      this.markedText = this.markText(0, "success");
      this.typedText = "";
      this.started = false;
      this.finished = false;
      this.charsCount = 0;
      this.typingCount = 0;
      this.typingSpeed = 0;
      this.typingAccuracy = 0;
      this.startTime = 0;
      this.isValidChar = true;
      this.currentTimer = 6;
      this.readonly = true;
    }
  }
});
